import React, { useEffect, useState } from "react";
import { SessionProvider } from "./SessionContext";
import { SocketProvider } from "./components/SocketContext";
import Body from "./components/Routes/Body";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import IOSInstallPrompt from "./components/IosInstallPrompt";
// import { listenForNotifications } from "./firebase/notification";
import LogViewer from "./LogViewer";
import { AuthContext, AuthProvider } from "./components/LoginPage/AuthContext";
import LoginComponent from "./components/LoginPage/LoginComponent";
import { ButtonVisibilityProvider } from "./Context/ButtonVisibilityContext";
import NotificationHandler from "./components/NotificationHandler";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { onMessageListener } from "./Utils/fcm";
import {checkToken} from './Utils/fcm';

function App() {
  const [isMobileOrPhablet, setIsMobileOrPhablet] = useState(false);

  const hideInstallPrompt = window.location.pathname === "/customer/login";

  // Check screen size on component mount and resize
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileOrPhablet(window.innerWidth <= 1024); // Show prompts only on mobile/phablet
    };

    checkScreenSize(); // Initial check
    window.addEventListener("resize", checkScreenSize); // Update on resize

    return () => window.removeEventListener("resize", checkScreenSize); // Cleanup
  }, []);

  // App.js
  useEffect(() => {
    const unsubscribe = onMessageListener((payload) => {
      toast(
        <div>
          <strong>{payload?.notification?.title}</strong>
          <p>{payload?.notification?.body}</p>
        </div>
      );
    });

    return () => unsubscribe && unsubscribe(); // cleanup
  }, []);

  // token refreshing------------->
  // this code block will refresh token evry one hour------------->
useEffect(() => {
  checkToken();
  const interval = setInterval(checkToken, 1 * 60 * 60 * 1000); 
  return () => clearInterval(interval);
}, []);


  return (
    <SessionProvider>
      <SocketProvider>
        <ButtonVisibilityProvider>
          <div className="app-container relative">
            {/* <LogViewer></LogViewer> */}
            <NotificationHandler />
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar
            />
            <Body />
            {/* Only show prompts for mobile and phablet */}
            {!hideInstallPrompt && isMobileOrPhablet && (
              <PWAInstallPrompt />
            )}{" "}
            {/* For Android/Desktop */}
            {!hideInstallPrompt && isMobileOrPhablet && <IOSInstallPrompt />}
            {/* For iOS */}
          </div>
        </ButtonVisibilityProvider>
      </SocketProvider>
    </SessionProvider>
  );
}

export default App;
